export default {
    small: "2.5rem",
    medium: "5rem"
}
